import { prefixerC } from '.'

export const ROUTE_PERMISO_APROBAR_VALE = prefixerC('permiso-aprobar-vale')
